"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _index = require("../../../../../index");

require("../styles/_popup.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var Popup = function (_Component) {
  function Popup() {
    var _temp, _this;

    (0, _classCallCheck2["default"])(this, Popup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2["default"])(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.handleClick = function (_ref) {
      var target = _ref.target,
          onOutsideClick = _this.props.onOutsideClick,
          creditsWrapper = document.querySelector(".credits-wrapper");
      creditsWrapper && creditsWrapper.contains(target) || !_this._popupRef || _this._popupRef.contains(target) || onOutsideClick();
    }, _this.setPopupRef = function (node) {
      _this._popupRef = node;
    }, _temp));
  }

  (0, _inherits2["default"])(Popup, _Component);

  var _super = _createSuper(Popup);

  return (0, _createClass2["default"])(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.handleClick, !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClick, !1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          creditType = _this$props.creditType,
          creditBalance = _this$props.creditBalance,
          isUnlimited = _this$props.isUnlimited,
          teams = _this$props.teams;
      return "TEAM" !== creditType || teams.length ? _react["default"].createElement("div", {
        className: "credits-info-popup",
        ref: this.setPopupRef
      }, "SHARE" === creditType ? _react["default"].createElement("div", {
        className: "credits-info-popup__share"
      }, _react["default"].createElement(_index.CreditsOverview, {
        creditBalance: creditBalance,
        isUnlimited: isUnlimited
      })) : _react["default"].createElement("div", {
        className: "credits-info-popup__teams"
      }, teams.map(function (_ref2) {
        var teamId = _ref2.teamId,
            imageUrl = _ref2.imageUrl,
            name = _ref2.name,
            teamBalance = _ref2.creditBalance,
            totalAvailableCredits = teamBalance.balance + teamBalance.rolloverBalance;
        return _react["default"].createElement("div", {
          key: teamId,
          className: "credits-info-popup__teams__team"
        }, _react["default"].createElement("div", {
          className: "credits-info-popup__teams__team__image"
        }, _react["default"].createElement(_uiKit.Image, {
          width: "40px",
          height: "40px",
          placeholderText: name,
          placeholderTextSize: 15,
          defaultIconColour: "regent",
          imageUrl: imageUrl
        })), _react["default"].createElement("div", {
          className: "credits-info-popup__teams__team__info"
        }, _react["default"].createElement("p", null, name), _react["default"].createElement("div", {
          className: "credits-info-popup__teams__team__info__credits"
        }, _react["default"].createElement(_uiKit.Icon, {
          name: "credits",
          size: 15,
          color: "black"
        }), _react["default"].createElement("span", null, "".concat(totalAvailableCredits, " video credits")))));
      }))) : _react["default"].createElement("div", {
        className: "credits-info-popup credits-info-popup--no-teams"
      }, _react["default"].createElement("span", null, "There are currently no teams with credits"));
    }
  }]), Popup;
}(_react.Component);

exports["default"] = Popup;